import React, { useEffect, useReducer } from 'react';
import PropTypes from 'prop-types';
import feedbackResponseReducer from '../reducers/feedbackResponse';
import useQuestions from '../hooks/useQuestions';
import getFeedbackResponseInitialState from '../utils/getFeedbackResponseInitialState';
import { initializeResponse } from '../actions/response';

export const feedbackResponse = React.createContext({
  answers: [],
  isAnonymous: false,
});
export const updateResponse = React.createContext();

export function FeedbackResponseState({ children }) {
  const { questions } = useQuestions();
  const [state, dispatch] = useReducer(
    feedbackResponseReducer,
    getFeedbackResponseInitialState(questions)
  );

  useEffect(() => {
    dispatch(initializeResponse(questions));
  }, [questions]);

  return (
    <feedbackResponse.Provider value={state}>
      <updateResponse.Provider value={dispatch}>
        {children}
      </updateResponse.Provider>
    </feedbackResponse.Provider>
  );
}

FeedbackResponseState.propTypes = {
  children: PropTypes.node.isRequired,
};
